import { render, staticRenderFns } from "./CActivity.vue?vue&type=template&id=f28256d0"
import script from "./CActivity.vue?vue&type=script&lang=js"
export * from "./CActivity.vue?vue&type=script&lang=js"
import style0 from "./CActivity.vue?vue&type=style&index=0&id=f28256d0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports